'use client';
import styled from 'styled-components';

export const StepsWrapper = styled.div`
  width: 100%;
  display: inline-grid;
  grid-template-columns: 26% 48% 26%;
  background: ${({ theme }) => theme.colors.background.base};
  padding: ${({ theme }) => theme.spacing(2, 0)};

  @media ${({ theme }) => theme.tablet} {
    padding: ${({ theme }) => theme.spacing(4, 0, 2)};
  }
`;

export const Steps = styled.div`
  margin: 0 auto;
  max-width: 500px;
  display: inline-grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
`;

export const Step = styled.p`
  ${({ active, theme }) =>
    active ? theme.typography.bodyBold : theme.typography.body}
  color: ${({ active, theme }) =>
    active ? theme.colors.text.secondary : theme.colors.border.light};
  text-align: center;
  display: ${({ active }) => (active ? 'inline-block' : 'none')};

  @media ${({ theme }) => theme.tablet} {
    display: inline-block;
  }
`;

export const CheckmarkWrapper = styled.span`
  /* negative margin-left to keep text in place when checkmark displayed
   * calc checkmark size and compensate for right margin
   * */
  margin-left: calc(-11px - ${({ theme }) => theme.spacing(2)});
  margin-right: ${({ theme }) => theme.spacing(2)};
`;

export const RightSegmentWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;
